import { render, staticRenderFns } from "./Getstarted.vue?vue&type=template&id=555d6f34&"
import script from "./Getstarted.vue?vue&type=script&lang=js&"
export * from "./Getstarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports